import { render, staticRenderFns } from "./InsightEditBox.vue?vue&type=template&id=38fe3f44&scoped=true"
import script from "./InsightEditBox.vue?vue&type=script&lang=ts"
export * from "./InsightEditBox.vue?vue&type=script&lang=ts"
import style0 from "./InsightEditBox.vue?vue&type=style&index=0&id=38fe3f44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fe3f44",
  null
  
)

export default component.exports